import script from "./Error403View.vue?vue&type=script&setup=true&lang=js"
export * from "./Error403View.vue?vue&type=script&setup=true&lang=js"

import "./Error403View.vue?vue&type=style&index=0&id=7118b449&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7118b449"]])

export default __exports__